import React, { FC } from 'react';

import {
  FormFieldsBorderRow,
  FormFieldsGradientRow,
  FormFieldsIdentitySection,
  FormFieldsSection,
  FormFieldsTitleStyleSection,
  FormFieldsUploadSection
} from '../components';

import {
  BG_COLOR_FIELDS,
  BORDER_COLOR_CONFIG,
  BORDER_WIDTH_CONFIG,
  FONT_WEIGHT_OPTIONS,
  TITLE_DEFAULTS,
  UPLOAD_FIELDS
} from './PopupFormFields.consts';

export const PopupFormFields: FC = (): React.ReactElement => {
  return (
    <React.Fragment>
      <FormFieldsSection heading="Popup">
        <FormFieldsIdentitySection />
      </FormFieldsSection>

      <FormFieldsSection
        heading="Popup Design"
        description="Customize the popup to fit your store theme."
        showSeparator
      >
        {/* TODO: Aligned with Jonathan — replace AcGradientInput (MUI) with new component when available */}
        <FormFieldsGradientRow fields={BG_COLOR_FIELDS} layout="half" />
        <FormFieldsUploadSection fields={UPLOAD_FIELDS} />
      </FormFieldsSection>

      <FormFieldsSection heading="Border" showSeparator separatorSpacing="lg">
        <FormFieldsBorderRow
          gradientConfig={BORDER_COLOR_CONFIG}
          widthConfig={BORDER_WIDTH_CONFIG}
          spacing="sm"
        />
      </FormFieldsSection>

      <FormFieldsTitleStyleSection
        heading="Title"
        nameField="title"
        colorField="fontColor"
        sizeField="fontSize"
        weightField="fontWeight"
        fontWeightOptions={FONT_WEIGHT_OPTIONS}
        defaults={TITLE_DEFAULTS}
        showSeparator
        separatorSpacing="lg"
        spacing="none"
      />
    </React.Fragment>
  );
};
